import { COLLECTION_URL } from '../utils/constants';

import { makeSDSNetworkCall } from './makeSDSNetworkCall';

export function getSDSCollection(collectionName: string) {
    return makeSDSNetworkCall(COLLECTION_URL + collectionName, 'GET');
}
